/**
 * 系统日志api
 * date:2022 04 15
 * author：brian
 */
 import httpRequest from '@/utils/request.js';

  /**查询列表 */
  export const sysLogPage = (params = {}) => httpRequest.httpGet({
    url: '/service/sysLog/page', params: {
      ...params
    }
  })
  /**获取详细 */
  export const sysLogDetail = (params = {}) => httpRequest.httpGet({
    url: '/service/sysLog/detail', params: {
      ...params
    }
  })
  /**获取树 */
  export const sysLogTree = (params = {}) => httpRequest.httpGet({
    url: '/service/sysLog/tree', params: {
      ...params
    }
  })
    /**设置tree */
    export const sysLogSet = (data) => httpRequest.httpPut('/service/sysLog/set',data)
    /**删除 */
    export const sysLogDel = (data) => httpRequest.httpdelete2('/service/sysLog/del',data)


    // 获取功能模块列表
    export const getModuleList = () => httpRequest.httpGet({
      url:'/service/sysLog/module'
    });
